import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENV_CONFIG, EnvironmentConfig } from 'src/app/core/enviroment-config';
import { CrudApiService } from 'src/app/core/service/abstract/rest-api.service';
import { ServiceOrder } from 'src/app/data/model/service-order';
import { ApiModule } from '../api.module';

@Injectable({
  providedIn: ApiModule,
})
export class ServiceOrderApiService extends CrudApiService<ServiceOrder> {
  constructor(http: HttpClient, @Inject(ENV_CONFIG) config: EnvironmentConfig) {
    super('resources/service-order', http, config);
  }
}
